<template>
  <div>
    <el-dialog title="调试地址" :close-on-click-modal="false" :visible.sync="dialogSiteVisible" :append-to-body="true" width="1000px">
      <div class="filter-container">
        <el-input v-trim v-model='listQuery.api_name' clearable filterable placeholder='请输入名称' class="filter-item" style="width: 200px" @change="handleFilter"></el-input>
        <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
        <el-button v-waves class="filter-item" type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      </div>
      <el-table v-loading="listLoading" class="siteTable" :key="tableKey" ref="table" :data="list" border fit stripe @current-change="handleSelectionChange" highlight-current-row height="500px" style="width:100%;" header-cell-class-name="headerstyle">
        <el-table-column label="选择" width="70" align="center">
          <template slot-scope="scope">
            <el-radio v-trim v-model="checked" :label="scope.row.id"></el-radio>
          </template>
        </el-table-column>
        <el-table-column label="操作"  align="center" width="100" sortable>
          <template slot-scope="scope">
            <span class="cp red" @click="handleDel(scope.row)"><i class="el-icon-delete"></i>删除</span>
            <span class="cp linkcolor" @click="handleEdit(scope.row)"><i class="el-icon-edit"></i>编辑</span>
          </template>
        </el-table-column>
        <el-table-column label="名称" prop="api_name" align="left" width="120" sortable>
          <template slot-scope="scope">
            <span>{{scope.row.api_name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="Api地址" prop="api_address" align="left" sortable>
          <template slot-scope="scope">
            <span>{{scope.row.api_address}}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建人/创建时间" prop="goods_name" align="left" width="200" sortable>
          <template slot-scope="scope">
            <span>{{scope.row.create_user_name}} <i v-if="scope.row.create_user_name">/</i> {{scope.row.create_time_yyyymmdd}}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新人/更新时间" prop="goods_name" align="left" width="200" sortable>
          <template slot-scope="scope">
            <span>{{scope.row.update_user_name}} <i v-if="scope.row.update_user_name">/</i> {{scope.row.update_time_yyyymmdd}}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page_no" :limit.sync="listQuery.page_size" @pagination="getList" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogSiteVisible = false">取消</el-button>
        <el-button type="primary" @click="saveSubmit()">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="titleName" :close-on-click-modal="false" :visible.sync="dialogFormVisible" :append-to-body="true" width="500px">
      <el-form ref="send" :rules="rules" :model="formData" label-position="right" label-width="100px">
        <el-form-item label="名称" prop="api_name">
          <el-input placeholder="请输入名称" v-trim v-model="formData.api_name" style="width:85%;"></el-input>
        </el-form-item>
        <el-form-item label="api地址" prop="api_address">
          <el-input placeholder="请输入api地址" v-trim v-model="formData.api_address" style="width:85%;" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="saveLoading" @click="saveBite()">确认</el-button>
      </div>  
    </el-dialog>
  </div>
</template>
<script>
import { GetDebugAddressList,AddDebugAddress,DelDebugAddress } from "@/api/login";
import waves from "@/directive/waves";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
  name: "apiSite",
  directives: { waves },
  components: { Pagination },
  props:{
    height:{
      type:Number
    }
  },
  data(){
    return{
      tableKey:0,
      total:0,
      listQuery:{
        api_name:"",
        page_size: 50,
        page_no: 1,
      },
      baseData:{},
      currentSelectItem:{},
      listLoading:true,
      saveLoading:false,
      list:[],
      dialogSiteVisible:false,
      dialogFormVisible:false,
      checked:null,
      titleName:"",
      formData:{
        api_name:"",
        api_address:"",
      },
      rules:{
        api_name: [{ required: true, message: '请输入名称', trigger: 'blur'}],
        api_address: [{ required: true, message: '请输入api地址', trigger: 'blur'}]
      },
    }
  },
  methods:{
    handleOpen(){
      this.dialogSiteVisible = true
      this.listQuery.api_name = ""
      this.getList()
      let data = JSON.parse(localStorage.getItem("baseApiData"))
      if(data){
        this.checked = data.id
      }
    },
    getList(){
      this.listLoading = true;
      GetDebugAddressList(this.listQuery).then((res) => {
        this.listLoading = false;
        if (res.data.res_status_code == 0) {
          this.list = res.data.res_content.data_list;
          this.total = res.data.res_content.total_count;
        } else {
          this.$message({
            type: "error",
            message: res.data.res_message,
          });
        }
      });
    },
    saveSubmit(){
      if (!this.checked) {
        return this.$message({
          type: "error",
          message: "请选择一个Api调试地址"
        });
      }                                                                                                                                             
      localStorage.setItem("baseApiData",JSON.stringify(this.currentSelectItem))
      this.dialogSiteVisible = false
      window.location.reload();
    },
    handleFilter(){
      this.listQuery.page_no = 1
      this.getList()
    },
    handleAdd(){
      this.dialogFormVisible = true;
      this.$nextTick(()=>{
        this.$refs.send.resetFields()
      })
      delete this.formData.id
    },
    handleDel(row){
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        DelDebugAddress({id: row.id}).then(res => {
          if(res.data.res_status_code == 0){
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getList()
          }else {
            this.$message({
              type: "error",
              message: res.data.res_message
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });          
      });
    },
    handleEdit(row){
      this.$set(this.formData,'id',row.id)
      this.$set(this.formData,'api_name',row.api_name)
      this.$set(this.formData,'api_address',row.api_address)
      this.dialogFormVisible = true;
    },
    //获取选择行信息
    handleSelectionChange(row){
      this.currentSelectItem = row
    },
    //保存api地址
    saveBite(){
      this.$refs.send.validate(valid => {
        if (valid) {
          this.saveLoading = true;
          AddDebugAddress(this.formData).then((res) => {
            this.saveLoading = false;
            if (res.data.res_status_code == 0) {
              this.$message({
                type: "success",
                message: "保存成功",
              });
              this.dialogFormVisible = false;
              this.getList()
            } else {
              this.$message({
                type: "error",
                message: res.data.res_message,
              });
            }
          });
        }
      })    
    },
  }
};
</script>
<style scoped>
.red{
  display: inline-block;
  color: red;
  margin-right: 5px;
}
.siteTable >>> .el-radio__label {
  display: none;
}
</style>